import React from 'react';
import { connect } from 'react-redux';
import { AlertBox, LinkText, Text } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';
import styled from 'styled-components';

import {
  DisqualificationAlertProps,
  DisqualificationAlertState
} from './DisqualificationAlert.types';
import analytics from '../../analytics';
import { SolarDisqualificationType } from '../../analytics/Analytics';

const ErrorTextColor = styled(Text)`
  color: #710000;
`;

const ErrorLinkColor = styled(LinkText)`
  color: #710000;
`;

class DisqualificationAlert extends React.Component<
  DisqualificationAlertProps,
  DisqualificationAlertState
> {
  constructor(props: DisqualificationAlertProps) {
    super(props);

    this.state = {
      isDisqualified: false
    };
  }

  componentDidMount() {
    const { name, disqualifiedFields } = this.props;

    if (disqualifiedFields.includes(name)) {
      this.setState({
        isDisqualified: true
      });
    }
  }

  componentDidUpdate() {
    const {
      name,
      message,
      postcode,
      productType,
      roofType,
      propertyType,
      disqualifiedFields
    } = this.props;
    const { isDisqualified } = this.state;

    if (disqualifiedFields.includes(name) && !isDisqualified) {
      analytics.disqualify(name as SolarDisqualificationType, message, {
        postcode: postcode,
        productType: productType,
        roofType: roofType,
        propertyType: propertyType
      });
      this.setState({
        isDisqualified: true
      });
    }

    if (!disqualifiedFields.includes(name) && isDisqualified) {
      this.setState({
        isDisqualified: false
      });
    }
  }

  render(): JSX.Element | null {
    const { heading, message, link, name } = this.props;
    const { isDisqualified } = this.state;

    if (!isDisqualified) {
      return null;
    }

    return (
      <Box marginBottom={6}>
        {link ? (
          <AlertBox type={'error'} data-id="postCodeAlertBox" heading={heading}>
            <ErrorTextColor size="sm">{message}</ErrorTextColor>
            <Box marginTop={3}>
              <ErrorTextColor size="sm">
                <ErrorLinkColor text={link[name].text} href={link[name].url} />
              </ErrorTextColor>
            </Box>
          </AlertBox>
        ) : (
          <AlertBox type={'error'} data-id="postCodeAlertBox" heading={heading} message={message} />
        )}
      </Box>
    );
  }
}

const mapStateToProps = (state: any) => ({
  propertyType: state.customer.propertyType,
  roofType: state.customer.roofType,
  postcode: state.customer.postcode,
  productType: state.customer.productType,
  disqualifiedFields: state.disqualification.disqualifiedFields
});

export default connect(mapStateToProps)(DisqualificationAlert);
